import React from 'react'

const CelebrationFilledIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='13'
    height='12'
    viewBox='0 0 13 12'
    fill='none'
    {...props}
  >
    <path
      d='M0.571289 11.7077L3.35551 3.91185L8.36711 8.92345L0.571289 11.7077ZM7.55969 6.44549L6.975 5.8608L10.0933 2.74247C10.3903 2.44549 10.7476 2.297 11.1653 2.297C11.5829 2.297 11.9402 2.44549 12.2372 2.74247L12.5713 3.07658L11.9866 3.66127L11.6525 3.32716C11.5226 3.19723 11.3602 3.13227 11.1653 3.13227C10.9704 3.13227 10.8079 3.19723 10.678 3.32716L7.55969 6.44549ZM5.33231 4.21811L4.74762 3.63343L5.08173 3.29932C5.21166 3.16939 5.27663 3.01162 5.27663 2.826C5.27663 2.64039 5.21166 2.48261 5.08173 2.35268L4.71978 1.99073L5.30447 1.40605L5.66642 1.768C5.9634 2.06498 6.11189 2.41765 6.11189 2.826C6.11189 3.23435 5.9634 3.58702 5.66642 3.88401L5.33231 4.21811ZM6.446 5.3318L5.86131 4.74712L7.86595 2.74247C7.99588 2.61254 8.06085 2.45013 8.06085 2.25524C8.06085 2.06034 7.99588 1.89793 7.86595 1.768L6.975 0.877045L7.55969 0.292358L8.45064 1.18331C8.74762 1.48029 8.89612 1.8376 8.89612 2.25524C8.89612 2.67287 8.74762 3.03018 8.45064 3.32716L6.446 5.3318ZM8.67338 7.55918L8.08869 6.97449L8.97964 6.08354C9.27663 5.78656 9.63393 5.63807 10.0516 5.63807C10.4692 5.63807 10.8265 5.78656 11.1235 6.08354L12.0144 6.97449L11.4298 7.55918L10.5388 6.66823C10.4089 6.5383 10.2465 6.47333 10.0516 6.47333C9.85667 6.47333 9.69426 6.5383 9.56433 6.66823L8.67338 7.55918Z'
      fill='currentColor'
    />
  </svg>
)

export default CelebrationFilledIcon
